<template>
	<div class="private-order-detail-title" :style="{ top: `${containerTop}px` }">
		<div class="title-layout">
			<span class="title-text">
				{{ product.name }}
			</span>

			<div v-if="isShowTabMenu" class="menu-wrapper">
				<span
					v-if="isHasDescription"
					class="description-tab-item"
					:class="{ active: detailActiveSection === 'product-description' }"
					@click="handleScrollToSectionId('product-description')"
				>
					Deskripsi
				</span>

				<span
					v-if="isHasContent"
					class="description-tab-item"
					:class="{ active: detailActiveSection === 'product-content' }"
					@click="handleScrollToSectionId('product-content')"
				>
					Konten
				</span>
			</div>

			<div class="blank-space"></div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const baseContainerTop = 18;

export default {
	props: {
		yPos: {
			type: Number,
			default: 0,
		},
		product: {
			type: Object,
			required: true,
		},
		isHasDescription: {
			type: Boolean,
			required: true,
		},
		isHasContent: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			isShowTabMenu: false,
		};
	},
	computed: {
		...mapGetters({
			detailActiveSection: 'privateOrder/detailActiveSection',
			detailTargetSectionId: 'privateOrder/detailTargetSectionId',
		}),
		containerTop() {
			const maxTop = 43;
			return this.yPos < maxTop ? baseContainerTop + this.yPos : maxTop + baseContainerTop;
		},
	},
	watch: {
		detailTargetSectionId: {
			handler(newValue) {
				if (newValue === '') return;
				const section = document.getElementById(newValue);
				if (section) {
					const sectionRect = section.getBoundingClientRect();
					const absoluteTop = sectionRect.top + window.pageYOffset;

					window.scrollTo({
						top: absoluteTop - 120,
						behavior: 'smooth',
					});
				}
			},
		},
	},
	methods: {
		...mapActions({
			setDetailTargetSectionId: 'privateOrder/setDetailTargetSectionId',
		}),
		handleScroll() {
			const sectionId = 'product-description-tab';
			const section = document.getElementById(sectionId);
			if (section) {
				const rect = section.getBoundingClientRect();
				if (rect.bottom - 114 <= 0) {
					this.isShowTabMenu = this.isHasDescription || this.isHasContent;
				} else {
					this.isShowTabMenu = false;
				}
			}
		},
		handleScrollToSectionId(sectionId) {
			this.setDetailTargetSectionId(sectionId);
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped lang="scss">
.private-order-detail-title {
	width: 100%;
	height: 46px;
	background-color: #ffffff;
	position: fixed;
	z-index: 1;
	border-bottom: 1px solid #ebebeb;
	box-shadow: rgba(49, 53, 59, 0.12) 0px 1px 6px 0px;
}

.title-layout {
	margin: 0 auto;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 948px;
	max-width: 948px;
	gap: 20px;

	@media screen and (min-width: 1280px) {
		width: 1188px;
		max-width: 1188px;
		gap: 32px;
	}

	& > span.title-text {
		font-weight: 600;
		font-size: 16px;
		color: #000000;
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		line-clamp: 1;
	}

	& > .menu-wrapper {
		width: 400px;
		min-width: 400px;
		max-width: 400px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		height: 100%;

		@media screen and (min-width: 1280px) {
			width: 508px;
			min-width: 508px;
			max-width: 508px;
		}

		& > span.description-tab-item {
			font-size: 16px;
			font-weight: 600;
			line-height: 24px;
			height: 100%;
			color: #80848e;
			cursor: pointer;
			transition: 0.1s all ease;
			border-bottom: 2.5px solid transparent;
			display: flex;
			align-items: center;

			&.active {
				color: #006dc7;
				border-bottom: 2.5px solid #006dc7;
			}
		}
	}

	& > .blank-space {
		width: 268px;
		min-width: 268px;
		max-width: 268px;
	}
}
</style>
